// extracted by mini-css-extract-plugin
export default {"container":"hero_container__RO85a","image_container":"hero_image_container__H8Gto","title":"hero_title__X4e6Q","date":"hero_date__tq9Xy","subtitle":"hero_subtitle__l4Rgs"};